import request from '@/utils/request'


// 生成小红书标题的测试接口
export function generateXhsTitlesTest(data) {
  return request({
    url: '/api/generate/free-api', // 对应你后端 Controller 的 @RequestMapping
    method: 'post',
    data: data
  })
}

// 生成小红书标题的接口
export function generateXhsTitles(content) {
  return request({
    url: '/api/title/generate', // 对应你后端 Controller 的 @RequestMapping
    method: 'post',
    data: {
      content: content  // 传给后端的参数
    }
  })
}

// 获取历史生成记录
export function getTitleHistory(userId) {
  return request({
    url: '/api/title/history',
    method: 'get',
    params: {
      userId: userId
    }
  })
}
